<template>
    <div class="card mb-3" style="padding: 40px; border-radius: 10px">
        <div class="row">
          <div class="col-md-8">
            <div class="card-body">
              <p style="font-weight: 400; font-size: 1.7rem;">{{ title }}</p>
              <p class="card-text" style="font-weight: 900; font-size: 3rem;">{{ value }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <img
              :src="imgRoute"
              class="img-fluid rounded-start"
              alt="..."
            />
          </div>
        </div>
      </div>
</template>
<script>
export default {
    props: {
      value: '',
      imgRoute: '',
      title: '',
      footerText: ''
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/aDashboard/nomina/cardnomina.vue